import { Typography } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Breakpoint } from 'types/utils';
import { ReviewsSorting } from '../pdp-reviews-sorting/reviews-sorting';
import { PdpOveralRating } from '../pdp-overal-rating/pdp-overal-rating';
import { PdpReviewsAddNew } from '../pdp-reviews-add-new/pdp-reviews-add-new';
import { sortDropdown, Containers, Styles, TopSideGrid, Controls } from './styles';
import { PdpReviewsPagination } from '../pdp-reviews-pagination';

export const DATA_QA_REVIEWS_CONTENT = 'reviews-content_mf-pdp';
export const DATA_QA_REVIEWS_TOP_SIDE = 'reviews-top-side_mf-pdp';
export const DATA_QA_REVIEWS_BOTTOM_SIDE = 'reviews-bottom-side_mf-pdp';
export const DATA_QA_REVIEWS_ADD_NEW = 'reviews-add-new_mf-pdp';
export const DATA_QA_REVIEWS_MOBILE_ADD_NEW = 'mobile-reviews-add-new_mf-pdp';

export namespace ContentBlocks {
  export const ReviewsSectionLite: React.FC = () => {
    const { t } = useTranslation();
    return (
      <>
        <Typography
          className={Styles.sectionSubtitle}
          variant="m"
          size="body_short"
          data-qa="reviews-section-subtitle_mf-pdp"
        >
          {t('reviews.ui.no-reviews')}
        </Typography>
        <Containers.ReviewsContentPdp data-qa={DATA_QA_REVIEWS_CONTENT}>
          <Containers.TopSide data-qa={DATA_QA_REVIEWS_TOP_SIDE}>
            <PdpReviewsAddNew data-qa={DATA_QA_REVIEWS_ADD_NEW} />
          </Containers.TopSide>
        </Containers.ReviewsContentPdp>
      </>
    );
  };

  export const ReviewsSectionFull: React.FC<{
    breakpoint: Breakpoint;
  }> = ({ breakpoint }) => {
    const isMobile = breakpoint === 'mobile';
    return (
      <Containers.ReviewsContentPdp data-qa={DATA_QA_REVIEWS_CONTENT}>
        <TopSideGrid data-qa={DATA_QA_REVIEWS_TOP_SIDE}>
          <PdpOveralRating data-qa="reviews-overall-rating_mf-pdp" />
          <PdpReviewsAddNew
            wide
            data-qa={isMobile ? DATA_QA_REVIEWS_MOBILE_ADD_NEW : DATA_QA_REVIEWS_ADD_NEW}
          />
        </TopSideGrid>
        <Controls>
          <ReviewsSorting isMobile={isMobile} className={isMobile ? sortDropdown : ''} />
        </Controls>

        <Containers.BottomSidePdp data-qa={DATA_QA_REVIEWS_BOTTOM_SIDE}>
          <PdpReviewsPagination breakpoint={breakpoint} />
        </Containers.BottomSidePdp>
      </Containers.ReviewsContentPdp>
    );
  };
}
